import React, { FC } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router';

import { CAMPAIGN_PRODUCTS, MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';

import { CampaignProductsPage } from './CampaignProductsPage';
import { PageNotFound } from '../PageNotFound';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';

const CampaignProductsRouteSwitch: FC = () => {
    const { path, url } = useRouteMatch();

    const campaignsEnabled = useFeature(CAMPAIGN_PRODUCTS);
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    if (!campaignsEnabled) {
        return <Redirect to={isMultiLanguageShopEnabled ? '/shop' : '/catalogue'} />;
    }

    return (
        <Switch>
            <Route path={`${path}/:loanFormat`}>
                <CheckLoanFormat>
                    <CampaignProductsPage />
                </CheckLoanFormat>
            </Route>
            <Route exact path={path}>
                <Redirect to={`${url}/all`} />
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};

export default CampaignProductsRouteSwitch;
